//own imports
import './SignUp.css';
//react imports
import React, {
    useEffect,  useState
} from 'react';
import { Link } from 'react-router-dom';
import 'reactjs-popup/dist/index.css';

//firebase
import { getAuth, createUserWithEmailAndPassword } from "firebase/auth";
import {
    initializeApp
} from "firebase/app";
import { addDoc, collection, query, getDocs, where } from "firebase/firestore";
import { getFirestore, Timestamp } from "firebase/firestore";

import { GoogleAuthProvider,  signInWithPopup } from "firebase/auth";

const provider = new GoogleAuthProvider();

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyBqU42lAjLn0NUdTEwAexRmyt3Bs333g0I",
    authDomain: "expensor-78ad1.firebaseapp.com",
    projectId: "expensor-78ad1",
    storageBucket: "expensor-78ad1.appspot.com",
    messagingSenderId: "685316790253",
    appId: "1:685316790253:web:79dcd75c79f9197fe439e4",
    measurementId: "G-LC26DDDV3H"
};

const emailRgex = new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
let inputPaswword;
let inputConfirmPassword;
let inputEmail;
let signUpBtn;
let dateLogin;
let errorSignInMessage;

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore();

const SignUp = () => {

    //Page title
    useEffect(() => {
        document.title = 'Sign Up';
    },[]);

    const [disabled, setDisabled] = useState(true);

    return ( 
        
        <div className="container" style={{minHeight:'100vh'}}>
            <div className="">
                <h1 className="header">Sign Up</h1>
                <div className="formContainer">
                <form>
                    <p className="errorMessage"></p>
                    <label className="label" htmlFor="uName">Username:</label><br />
                    <input className="inputField" placeholder="John Doe" onInput={checkUserName} type="text" name="uName" id="uName" /><br />
                    <span className="errorMessage errorUname"></span>
                    <label className="label" htmlFor="uEmail">Email:</label><br />
                    <input onInput={checkEmail} className="inputField" placeholder="john.doe@gmail.com" type="email" name="uEmail" id="uEmail" /><br />
                    <span className="errorMessage errorEmail"></span>
                    <label className="label" htmlFor="uPass">Password:</label><br />
                    <input onInput={checkifPasswordsMatch} className="inputField"  type="password" name="uPass" id="uPass" /> <br />
                    <label className="label" htmlFor="uPass">Confirm Password:</label><br />
                    <input onInput={checkifPasswordsMatch} className="inputField"type="password" name="uRPass" id="uRPass" />
                    <span className="errorMessage errorMessagePaswword"></span>
                </form>
                </div>
                <div>
                    <button disabled={disabled} style={{ filter: 'grayscale(1)' }} className='btn-primary' onClick={signUpWithEmailAndPassword}>Sign Up</button> <br /> <br />
                    <button className='btn-primary' onClick={googleAuth}>Sign Up with Google</button> <br />

                    {/*                    <button className='btn-primary' onClick={facebookAuth}>Sign Up with Facebook</button> <br />

                    {/*<button className='btn-primary' onClick={facebookAuth}>Sign Up with Facebook</button> <br />

                    <button className='btn-primary' onClick={githubAuth}>Sign Up with Github</button> <br /> <br />*/}
                    <Link to="/signIn"><button className='btn-secondary' >Sign In</button></Link>
                </div>               
            </div>
        </div>
    );

    function checkUserName()
    {

        const uNameError = document.getElementsByClassName("errorUname")[0];
        const uName = document.getElementById('uName');
        inputEmail = document.getElementById('uEmail');
        inputConfirmPassword = document.getElementById('uRPass');
        inputPaswword = document.getElementById('uPass');
        signUpBtn = document.getElementsByClassName('btn-primary')[0];
        if (uName.value.length > 3)
        {
            uName.style.borderColor = 'green';
            uNameError.style = "color: green";
            uNameError.innerHTML = "User name is valid";
            if ((inputEmail.value !== '' || inputEmail.value !== null) && emailRgex.test(inputEmail.value) && uName.value.length > 3 && (inputPaswword.value !== '' && inputPaswword.value !== null) && inputConfirmPassword.value === inputPaswword.value) {
                signUpBtn.classList.remove("btnSignUpDisabled");
                signUpBtn.style.filter = "grayscale(0)";
                setDisabled(false);
            }
        }
        else
        {
            uName.style.borderColor = 'red';
            uNameError.style = "color: red";
            uNameError.innerHTML = "User name is unvalid, please longer than 3 characters";
            signUpBtn.classList.add("btnSignUpDisabled");
            signUpBtn.style.filter = "grayscale(1)";
            setDisabled(true);
        }
    }

    function checkifPasswordsMatch() {
        inputPaswword = document.getElementById('uPass');
        inputConfirmPassword = document.getElementById('uRPass');
        signUpBtn = document.getElementsByClassName('btn-primary')[0];
        inputEmail = document.getElementById('uEmail');
        const password = inputPaswword.value;
        const confirmPassword = inputConfirmPassword.value;
        const errorMessage = document.getElementsByClassName('errorMessagePaswword')[0];
        const userNameInput = document.getElementById('uName');

        if (password === null || password === '') {
            signUpBtn.style.filter = "grayscale(1)";
            setDisabled(true);
            errorMessage.innerHTML = "Please fill in a password.";
            errorMessage.style.color = "red";
            inputConfirmPassword.style.border = '1px solid red';
            inputPaswword.style.border = '1px solid lightslategray';
        }
        else {
            inputPaswword.style.border = '1px solid green';
            if (password === confirmPassword) {
                inputConfirmPassword.style.border = '1px solid green';
                errorMessage.innerHTML = "Passwords match.";
                errorMessage.style.color = 'green';
                if ((inputEmail.value !== '' || inputEmail.value !== null) && emailRgex.test(inputEmail.value) && userNameInput.value.length > 3) {
                    signUpBtn.classList.remove("btnSignUpDisabled");
                    signUpBtn.style.filter = "grayscale(0)";
                    setDisabled(false);
                }
            }
            else {
                inputConfirmPassword.style.border = '1px solid red';
                signUpBtn.style.filter = "grayscale(1)";
                setDisabled(true);
                errorMessage.innerHTML = "Passwords do not match.";
                errorMessage.style.color = 'red';
            }
        }
    }

    function checkEmail() {
        errorSignInMessage = document.getElementsByClassName('errorMessagePaswword')[0];
        inputPaswword = document.getElementById('uPass');
        inputConfirmPassword = document.getElementById('uRPass');
        signUpBtn = document.getElementsByClassName('btn-primary')[0];
        inputEmail = document.getElementById('uEmail');
        const email = inputEmail.value;
        const emailErorr = document.getElementsByClassName('errorEmail')[0];
        const userNameInput = document.getElementById('uName');

        if (email === '' || email == null) {
            signUpBtn.style.filter = "grayscale(1)";
            setDisabled(true);
            inputEmail.style.border = '1px solid red';
            emailErorr.innerHTML = 'Please fill in an email.';
            emailErorr.style.color = 'red';
        }
        else {
            if (emailRgex.test(email)) {
                inputEmail.style.border = '1px solid green';
                emailErorr.innerHTML = 'Valid email.';
                emailErorr.style.color = 'green';
                if ((inputPaswword.value !== '' && inputPaswword.value !== null) && inputConfirmPassword.value === inputPaswword.value && userNameInput.value.length > 3) {
                    signUpBtn.classList.remove("btnSignUpDisabled");
                    signUpBtn.style.filter = "grayscale(0)";
                    setDisabled(false);
                }
            }
            else {
                signUpBtn.style.filter = "grayscale(1)";
                setDisabled(true);
                inputEmail.style.border = '1px solid red';
                emailErorr.innerHTML = 'Email not valid.';
                emailErorr.style.color = 'red';
            }
        }
    }
};

function googleAuth() {
    dateLogin = new Date();
    const auth = getAuth(app);
    errorSignInMessage = document.getElementsByClassName('errorSignInMessage')[0];
    signInWithPopup(auth, provider)
        .then((result) => {
            // This gives you a Google Access Token. You can use it to access the Google API.
            //const credential = GoogleAuthProvider.credentialFromResult(result);
            //const token = credential.accessToken;
            // The signed-in user info. deze info versturen naar de andere pagina's om door te routeren naar alle pagina's
            const user = result.user;
            // ...
            createPriveGroupForUser(user.uid, user, user.displayName);

        }).catch((error) => {
            // Handle Errors here.
            //const errorCode = error.code;
            const errorMessage = error.message;
            // The email of the user's account used.
            //const email = error.email;
            // The AuthCredential type that was used.
            //const credential = GoogleAuthProvider.credentialFromError(error);
            // ...
            errorSignInMessage.innerHTML = errorMessage;
        });
};

/*function facebookAuth() {
    alert("not yet implmented");
};

function githubAuth() {
    alert("not yet implmented");
};*/

function signUpWithEmailAndPassword(){
    const email = document.getElementById('uEmail').value;
    const password = inputConfirmPassword.value;
    const userName = document.getElementById('uName').value;
    const auth = getAuth(app);
    createUserWithEmailAndPassword(auth, email, password)
        .then((userCredential) => {
            // Signed in 
            const user = userCredential.user;
            createPriveGroupForUser(user.uid, user, userName);
            // ...
            //laten wachten tot de group gecreeerd is. anders wordt er geen group aangemaakt.
        })
        .catch((error) => {
            const errorCode = error.code;
            const errorMessage = error.message;
            // ..
            if (errorCode === 'auth/weak-password') {
                document.getElementsByClassName('errorMessage')[0].innerHTML = "Your passwoord should be at least 6 characters long.";
            }
            else if (errorCode === 'auth/email-already-in-use'){
                document.getElementsByClassName('errorMessage')[0].innerHTML = "This email address is already being used. Please go to sign in.";
            }
            else{
                document.getElementsByClassName('errorMessage')[0].innerHTML = errorMessage + "| Code => " + errorCode;
            }
        });
}

async function createPriveGroupForUser(uid, user, userName) {

    goToHome();

    async function writeToDB(_callback ) {

        errorSignInMessage = document.getElementsByClassName('errorSignInMessage')[0];
        try {
            let teller = 0;
            const users = await getDocs(query(collection(db, "Users"), where("userId", "==", uid)));
            await users.forEach(userss => {
                teller++;
            })
            if (teller > 0) {

                _callback();
            }
            else {
                if (new Date(user.metadata.creationTime).toUTCString() > new Date(dateLogin).toUTCString()) {
                    const docRef = await addDoc(collection(db, "Groups"), {
                        name: "Prive",
                        color: "green",
                        description: "",
                        owner: uid,
                        expenses: [],
                        members: [uid],
                        admins: [uid],
                        categories: [],
                        isDeleted: false,
                    });

                     addDoc(collection(db, "Groups", docRef.id, "Members"), {
                        uid: uid,
                        membership: Timestamp.fromDate(new Date("1/1/2200")),
                        enteredGroup: Timestamp.now(),
                        permissions: [{ AddRemoveMemersFromGroup: true, EditRemoveGroup: true, EditOthersPermissions: true, CreateRemoveGroupCategories: true, EditRemoveOtherTheirExpenses: true }]
                    });
                    await addDoc(collection(db, 'Users'), {
                        userName: userName,
                        userId: uid,
                    });
                }
            }
        } catch (e) {
            errorSignInMessage.innerHTML = "Error adding document: " + e;
        }
        _callback();
    }

    function goToHome() {
        writeToDB(function () {
           window.location.href = "/";
        });
    }
}

export default SignUp;